module.exports = __webpack_public_path__ + "img/昭平台库区乡.36ff49b1.png";